/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Summer_Mode_TextInputs */



/**
* | output |
* | --- |
* | "Thermostatic valves open to 100% to prevent seizing The boiler room shuts down the radiator and air heater networks and continues to heat only if DHW is avai..." |
*
* @param {Season_Summer_Mode_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_summer_mode_text = /** @type {((inputs?: Season_Summer_Mode_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Summer_Mode_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Thermostatic valves open to 100% to prevent seizing\nThe boiler room shuts down the radiator and air heater networks and continues to heat only if DHW is available.")
	return /** @type {LocalizedString} */ ("Les têtes th. s'ouvrent à 100% pour éviter les grippages\nLa chaufferie arrête les x radiateurs et aérothermes et continue à chauffer seulement s'il y a de l'ECS")
});